import { render, staticRenderFns } from "./status.vue?vue&type=template&id=1379b63e&scoped=true&"
import script from "./status.vue?vue&type=script&lang=js&"
export * from "./status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1379b63e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1379b63e')) {
      api.createRecord('1379b63e', component.options)
    } else {
      api.reload('1379b63e', component.options)
    }
    module.hot.accept("./status.vue?vue&type=template&id=1379b63e&scoped=true&", function () {
      api.rerender('1379b63e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/status.vue"
export default component.exports